import { render } from "./StatisticsView.vue?vue&type=template&id=213d5654&scoped=true&ts=true"
import script from "./StatisticsView.vue?vue&type=script&lang=ts"
export * from "./StatisticsView.vue?vue&type=script&lang=ts"

import "./StatisticsView.vue?vue&type=style&index=0&id=213d5654&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-213d5654"]])

export default __exports__